import ReactSelect, {
  ClearIndicatorProps,
  components,
  DropdownIndicatorProps,
  GroupBase,
  OptionProps,
  SingleValue,
  SingleValueProps,
} from "react-select"
import classNames from "classnames"

import "./select.scss"

import { UITypes } from "types"
import { ReactComponent as IconSelect } from "assets/svg/icon-select.svg"
import { ReactComponent as IconTableCross } from "assets/svg/icon-table-cross.svg"

import styles from "./index.module.scss"

const DropdownIndicatorComponent = (props: DropdownIndicatorProps<UITypes.Option>) => {
  return (
    <components.DropdownIndicator {...props}>
      <span
        className={classNames(styles.iconArrow, {
          [styles.open]: props?.selectProps?.menuIsOpen,
        })}
      >
        <IconSelect />
      </span>
    </components.DropdownIndicator>
  )
}

const ClearIndicator = (props: ClearIndicatorProps<UITypes.Option>) => {
  const { innerProps } = props
  return (
    <div {...innerProps} className={styles.clearIcon}>
      <IconTableCross />
    </div>
  )
}

const ColorOption = (props: OptionProps<UITypes.Option, false, GroupBase<UITypes.Option>>) => {
  const { data, innerRef, innerProps } = props

  return (
    <div ref={innerRef} {...innerProps} className={styles.colorOption}>
      <span style={{ color: data.color || "initial" }}>{data.label}</span>
    </div>
  )
}

const ColorSingleValue = (props: SingleValueProps<UITypes.Option, false, GroupBase<UITypes.Option>>) => {
  const { data } = props
  const color = data?.color || "initial"

  return (
    <components.SingleValue {...props} className={styles.colorSingleValue}>
      <span style={{ color }}>{data?.label}</span>
    </components.SingleValue>
  )
}

export interface TableSelectContentProps {
  name?: string
  options?: UITypes.Option[]
  placeholder?: string
  value: UITypes.Option | null
  isColorSelect?: boolean
  onChange: (option: UITypes.Option | null) => void
}

export const TableSelectContent = ({
  name,
  options,
  placeholder,
  value,
  isColorSelect = false,
  onChange,
}: TableSelectContentProps) => {
  const handleChange = (data: SingleValue<UITypes.Option>) => {
    onChange(data || null)
  }

  const customComponents = isColorSelect
    ? {
        Option: ColorOption,
        SingleValue: ColorSingleValue,
        DropdownIndicator: DropdownIndicatorComponent,
        ClearIndicator,
      }
    : {
        DropdownIndicator: DropdownIndicatorComponent,
        ClearIndicator,
      }

  return (
    <div className={classNames(styles.field)}>
      <ReactSelect
        isMulti={false}
        options={options}
        classNamePrefix="filter"
        value={value}
        isClearable={true}
        hideSelectedOptions={true}
        className="custom"
        name={name}
        placeholder={placeholder}
        onChange={handleChange}
        components={customComponents}
      />
    </div>
  )
}
